import React from 'react';
import {
  Sec,
  SecTitle,
  Box,
  Mini,
  MiniItem,
  ReportTable,
  Note,
} from '../styled';
import LoadingML from '@/components/LoadingML';
import { fmtThousand } from '@/utils/comUtil';

// 访问城市 TOP5：按 demo-开发用.html 视觉
//   标题 + mini（PV 合计 / 上海本地占比 / 外地合计占比）+ 表格（城市/PV/占比/可视化）
// 数据：state.performSales.geoTop5
const GeoTop5 = ({ data, loading }) => {
  const {
    pvTotal = 0,
    localShare = 0,
    outsideShare = 0,
    geo = [],
  } = data || {};
  const top = geo[0]?.p || 1;

  return (
    <Sec>
      <SecTitle>
        访问城市 TOP5<em>剧目按详情页 PV 的 IP 归属地 T+1</em>
      </SecTitle>
      <Box>
        <LoadingML loading={loading ? 1 : 0}>
          <Mini>
            <MiniItem>
              <div className="l">详情页 PV 合计</div>
              <div className="v" style={{ color: '#1f2329' }}>
                {fmtThousand(pvTotal, 0)}
              </div>
            </MiniItem>
            <MiniItem>
              <div className="l">上海本地占比</div>
              <div className="v">{(localShare * 100).toFixed(1)}%</div>
            </MiniItem>
            <MiniItem>
              <div className="l">外地合计占比</div>
              <div className="v">{(outsideShare * 100).toFixed(1)}%</div>
            </MiniItem>
          </Mini>

          <ReportTable>
            <thead>
              <tr>
                <th style={{ width: '16%' }}>城市</th>
                <th style={{ width: '16%' }}>PV</th>
                <th style={{ width: '12%' }}>占比</th>
                <th className="bar-cell">可视化</th>
              </tr>
            </thead>
            <tbody>
              {geo.map((g) => {
                const widthPct = ((g.p / top) * 100).toFixed(1);
                const barCls = g.other ? ' gray' : '';
                const dim = g.other ? { color: '#8c939e' } : null;
                return (
                  <tr key={g.name}>
                    <td style={dim}>{g.name}</td>
                    <td style={dim}>{fmtThousand(g.pv, 0)}</td>
                    <td style={dim}>{(g.p * 100).toFixed(1)}%</td>
                    <td className="bar-cell">
                      <div className="bar-bg">
                        <div
                          className={`bar${barCls}`}
                          style={{ width: `${widthPct}%` }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </ReportTable>

          <Note>
            <b>口径：按 PV 统计，不去重到人。</b>
            同一用户多次访问、或在不同城市访问均会重复计入，本表反映流量的地域分布，不代表观众人数分布。
            地域由访问 IP 定时清洗解析得到，非实时。
          </Note>
        </LoadingML>
      </Box>
    </Sec>
  );
};

export default GeoTop5;
